import React from "react";
import {
    makeStyles,
    createStyles,
    Theme,
    Tooltip, withStyles
} from "@material-ui/core";
/* eslint-disable */

export const LightTooltip = withStyles((theme: Theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: 'rgba(0, 0, 0, 0.87)',
        boxShadow: theme.shadows[1],
        fontSize: 12,
    },
}))(Tooltip);

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        c_pointer: {
            cursor: "pointer"
        },
        ml_auto: {
            marginLeft: "auto"
        },
        wh_16: {
            width: "18px !important",
            height: "18px !important"
        }
    })
);
export interface WarningTagProps {
    tooltipClicked: any;
    infoIconMsg: string;
    infoLightImg: any;
}
export const WarningTag = (props: WarningTagProps) => {
    const classes = useStyles();
    const [infoIconMsg, setInfoIconMsg] = React.useState<string>("Information");
    const {
        tooltipClicked,
        infoLightImg
    } = props;
    return (
        <LightTooltip
            title={infoIconMsg}
            placement="right-end"
            onClose={() => {
                setInfoIconMsg(infoIconMsg);
            }}
            onOpen={() => {
                setInfoIconMsg("Information");
            }}
        >
            <img
                src={infoLightImg}
                alt="info"
                className={`${classes.wh_16} ${classes.ml_auto} ${classes.c_pointer}`}
                style={{
                    marginTop: 'auto',
                    marginLeft: 5
                }}
                onClick={() => {
                    setInfoIconMsg(tooltipClicked);
                }}
            />
        </LightTooltip>
    );
};